import { AxiosResponse } from "axios";
import * as React from "react";
import Button from "../../../../../common/components/shared/button/button";
import { HttpError } from "../../../../../common/components/shared/httpError/httpError";
import { Popup } from "../../../../../common/components/shared/popup/popup";
import { HttpErrorModel } from "../../../../../common/models/httpError";
import { Api } from "../../../../../helpers/api";
import i18n from "../../../../../i18n/i18n";
import {ReactComponent as AllowIcon} from "../../../../../statics/icons/icon_allowPopup.svg";

interface AllowWithTcrRequiredPopupProps {
    displayPopup: boolean;
    confirm: () => void;
    closePopup: () => void;
    goToTcr: () => void;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

export default function AllowWithTcrRequiredPopup(props: AllowWithTcrRequiredPopupProps): React.ReactElement {
    const content = (
        <div>
            {i18n.t("transportation.order.status.allowWithTcrRequiredPopup.contentPart1")}
            <b>{i18n.t("transportation.order.status.allowWithTcrRequiredPopup.contentSkip")}</b>
            {i18n.t("transportation.order.status.allowWithTcrRequiredPopup.contentPart2")}
            <b> {i18n.t("transportation.order.status.allowWithTcrRequiredPopup.contentTcrBold")}</b>
        </div>);

    return (
        <Popup
            open={props.displayPopup}
            className="allow-with-tcr-required-popup"
            header={i18n.t("transportation.order.status.allowWithTcrRequiredPopup.header")}
            icon={<AllowIcon/>}
            content={content}
            actionText={i18n.t("transportation.order.status.allowWithTcrRequiredPopup.actionText")}
            action={props.confirm}
            cancel={props.closePopup}
            otherBtn={
                <Button
                    type="secondary"
                    onClick={props.goToTcr}
                    testId="allow-with-tcr-required-popup-go-to-tcr-btn"
                    text={i18n.t("transportation.order.status.allowWithTcrRequiredPopup.cancelText")}
                />
            }
            hideCancelButton
            testId="allow-with-tcr-required-popup"
            httpError={
                <>
                    {!Api.isSuccess(props.response) && (
                        <HttpError
                            response={props.response}
                            cause={i18n.t("transportation.order.status.allowWithTcrRequiredPopup.allowWithTcrRequiredErrorSuffix")}
                        />
                    )}
                </>
            }
        />
    );
}
